import { render, staticRenderFns } from "./SectionFreeText.vue?vue&type=template&id=486c3d77&scoped=true&"
import script from "./SectionFreeText.vue?vue&type=script&lang=ts&"
export * from "./SectionFreeText.vue?vue&type=script&lang=ts&"
import style0 from "./SectionFreeText.vue?vue&type=style&index=0&id=486c3d77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c3d77",
  null
  
)

export default component.exports